<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-monitor"></i> 物资类别</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="70px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 分类 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="物资分类">
              <el-input
                v-model="queryParams.category"
                placeholder="请输入分类名称"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <!-- 名称 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="物资名称">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入名称"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">
            新增
          </el-button>
        </div>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="category" label="分类"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column
          prop="totalCategoryCount"
          label="总类数"
        ></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="creatorName" label="创建人"></el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" type="primary"
              >编辑</el-button
            >
            <el-button size="mini" @click="deleteItem(scope.row)" type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增物资类别弹窗 -->
      <el-dialog
        :title="isEdit ? '编辑' : '新增'"
        :visible.sync="dialogVisible"
        width="500px"
        @close="resetForm"
        class="dialog-container"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="form" :rules="rules" ref="formRef" label-width="80px">
          <el-form-item label="分类" prop="category">
            <el-select
              v-model="form.category"
              placeholder="请选择分类"
              style="width: 350px"
            >
              <el-option label="固定物资" value="固定物资" />
              <el-option label="低值易耗" value="低值易耗" />
              <el-option label="日常消耗" value="日常消耗" />
              <el-option label="食材物资" value="食材物资" />
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入名称"
              style="width: 350px"
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" class="cancel-button"
            >取消</el-button
          >
          <el-button type="primary" @click="saveItem" class="save-button"
            >保存</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  assetsCategoryPage,
  assetsCategoryAddOrEdit,
  assetsCategoryDelete,
} from "@/api/material";
import PaginationBar from "@/components/PaginationBar";

export default {
  name: "MaterialManagement",
  components: { PaginationBar },
  data() {
    return {
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      queryParams: {
        category: "",
        name: "",
      },
      tableData: [],
      dialogVisible: false,
      form: {
        category: "",
        name: "",
      },
      isEdit: false,
      rules: {
        category: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      assetsCategoryPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.queryParams.category = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.dialogVisible = true;
      this.false = true;
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.form = {
          category: row.category,
          name: row.name,
          id: row.id,
        };
      });
    },

    saveItem() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        assetsCategoryAddOrEdit(this.form).then(() => {
          this.dialogVisible = false;
          this.handleQuery();
          this.$message.success("操作成功");
        });
      });
    },

    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.isEdit = false;
      this.form = {
        category: "",
        name: "",
      };
    },
    deleteItem(row) {
      this.$confirm("确定删除当前类别？", "提示", { type: "warning" })
        .then(() => {
          // 删除逻辑
          assetsCategoryDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
  },
  created() {
    this.handleQuery();
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-container {
  /* 调整 dialog 的样式 */
  border-radius: 8px;
}
.form-input {
  width: 100%;
  margin-top: 10px;
}

.el-form-item {
  margin-bottom: 20px; /* 调整每个表单项的间距 */
}

.dialog-footer {
  /* 底部按钮区间距和对齐 */
  text-align: center;
}

.cancel-button,
.save-button {
  margin-left: 10px; /* 按钮间隔 */
}

.save-button {
  background-color: #409eff;
  border-color: #409eff;
}

.cancel-button {
  background-color: #f5f5f5;
  border-color: #dcdfe6;
}
</style>
